<template>
  <div class="brand-banner-wrapper">
    <div class="brand-banner">
      <div class="brand-banner__header">
        <h2 class="brand-banner__title display-m">{{ title }}</h2>
        <p class="brand-banner__subtitle body-m">{{ subtitle }}</p>
      </div>
      <div class="brand-banner__brands">
        <UiSmartLink
          v-for="(brand, index) in brands"
          class="brand-banner__brand"
          :key="brand.image.alt"
          :to="brand.url"
          :target="brand.isOpenInNewTab ? '_blank' : '_self'"
          @click="emit('banner-clicked', index)"
        >
          <UiSmartImage
            aspect-ratio="revert"
            objectFit="contain"
            v-bind="brand.image"
          />
        </UiSmartLink>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { BrandBannerProps } from './types'
import UiSmartImage from '@sephora-asia/ui-smart-image'
import UiSmartLink from '@sephora-asia/ui-smart-link'

interface Emits {
  (e: 'banner-clicked', index: number): void
}

const emit = defineEmits<Emits>()

defineProps<BrandBannerProps>()
</script>

<style lang="scss" scoped>
.brand-banner {
  margin: auto;
  width: revert;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  flex-direction: column;

  &__header {
    min-width: 312px;
    max-width: 312px;
  }

  &__brands {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px 8px;
    max-width: 984px;
  }

  &__brand {
    padding: 8px 12px;
    background-color: var(--color-base-white);
    border: 1px solid var(--color-base-grey-10);
    border-radius: var(--size-radius-medium);
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .smart-image {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@include media(desktop, widescreen, fullhd) {
  .brand-banner {
    width: fit-content;
    flex-direction: row;
    gap: 24px;

    &__header {
      padding-block: 8px;
    }

    &__title {
      margin-bottom: 4px;
    }

    &__brands {
      min-width: 656px;
      grid-template-columns: repeat(6, 1fr);
    }

    &__brand {
      height: 80px;
    }
  }
}

@include media(widescreen, fullhd) {
  .brand-banner__brands {
    gap: 24px;
  }
}
</style>
